// extracted by mini-css-extract-plugin
module.exports = {"chip":"complete-count-chip_chip__mBqtJ","chip-complete":"complete-count-chip_chip-complete__f910i"};